export const el = {
  ADD_COLOR_STRING_KEY: 'Add color',
  ADD_TEXT_KEY: 'Προσθήκη κειμένου',
  ADD_TO_ORDER_KEY: 'Add to order',
  ADD_TO_CART: 'Προσθήκη στο καλάθι',
  ADD_TEMPLATE: 'Add Template',
  ADJUST_SIZE_KEY: 'Adjust Size',
  ADJUST_TRANSPARENCY_KEY: 'Adjust Transparency',
  AGREE_FOR_PRIVACY_TITLE_KEY:
    "By clicking Done, you agree to the HP's terms of use and privacy statement.",
  ALIGN_BOTTOM_KEY: 'Ευθυγράμμιση Κάτω',
  ALIGN_CENTER_KEY: 'ευθυγραμμίστε το κέντρο',
  ALIGN_KEY: 'ευθυγραμμίζω',
  ALIGN_LEFT_KEY: 'Align Left',
  ALIGN_MIDDLE_KEY: 'ευθυγραμμίστε το μέσο',
  ALIGN_RIGHT_KEY: 'Align Right',
  ALIGN_TOP_KEY: 'Ευθυγραμμίστε την κορυφή',
  ALL_TAB_TITLE_KEY: 'Όλα',
  ALMOST_DONE_TITLE_KEY: 'Almost done!',
  AND_KEY: 'and',
  APPLY_KEY: 'Apply',
  AREA_CODE: 'Area code',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'Browse the content and select the images for your design, or upload your own',
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Preview your design, or fine-tune the details',
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Customize the design and add other elements to your project',
  BASIC_HELPER_INSTRUCTION4_KEY:
    'When the design is ready, click NEXT to make a final check and place your order.',
  BACK_KEY: 'Back',
  BACKGROUND_KEY: 'Φόντο',
  BACKGROUND_UPPER_CASE_KEY: 'BACKGROUND',
  BACKGROUND_CONTRAST_KEY: 'Background Contrast',
  BLANK_INSPIRATION_CATEGORY_KEY:
    'Δεν υπάρχουν εισροές που βρέθηκαν κάτω από αυτήν την κατηγορία',
  BRING_TO_FRONT_KEY: 'Μεταφορά μπροστά',
  CANCEL_TEXT_KEY: ' Άκυρο ',
  CENTIMETERS_KEY: 'εκατοστά',
  CM_KEY: 'cm.',
  CHANGE_YOUR_SETTINGS_KEY: 'Change your project settings',
  CHECKBOX_CONTENT1: 'I want to receive the Pattern Design© newsletter',
  CHECKBOX_CONTENT2:
    'I authorize HP to create an account in Pattern Design© services on my behalf',
  CHOOSE_FROM_COMPUTER_KEY: 'Choose from computer',
  CHOOSE_RIP_OPTIONS: 'Choose one of these compatible third party RIPs',
  CHOOSE_FILE_KEY: 'Επιλογή αρχείου',
  CITY: 'City',
  CLEAR_ALL_KEY: 'Απαλοιφή όλων',
  CLEAR_COLOR_KEY: 'Απαλοιφή χρώματος',
  CLOSE_WINDOW_KEY: 'Κλείσιμο παράθυρου',
  CLEAR_ALL_OBJECTS: 'Απαλοιφή όλων των αντικειμένων',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'Η ενέργεια αυτή θα καταργήσει όλα τα αντικείμενα από το φόντο',
  CLEAR_DESIGN_KEY: 'Clear design',
  COLOR_KEY: 'Χρώμα',
  CONTINUE_KEY: 'Συνέχεια...',
  COMPANY: 'Company',
  CONGRATULATIONS_KEY: 'Congratulations!',
  CONFIRM_PASSWORD: 'Confirm password',
  CONFIRM_PATTERN_ACCOUNT_KEY: "Don't have a Pattern Design account yet?",
  CONFIRM_VECTEEZY_ACCOUNT_KEY: "Don't have a Vecteezy account yet?",
  COUNTRY: 'Country',
  CREATE_ACCOUNT: 'Create account',
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Custom',
  CUSTOM_PRICE_SIGN_IN_KEY: 'Sign-in in the next step to see custom pricing.',
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: 'Create new',
  DESIGN_KEY: 'Σχέδιο',
  DELETE_KEY: 'Διαγραφή',
  DOCUMENT_COLORS: 'Χρώματα εγγράφων',
  DONE: 'Done!',
  DONE_KEY: 'Τέλος',
  DONT_SHOW_ALERT_KEY: "Don't show again",
  DOWNLOAD_COLUMN_HEADER_KEY: 'Λήψη',
  DOWNLOAD_APP_TITLE_KEY: 'Μπορείτε να λάβετε την εφαρμογή από εδώ:',
  DOWNLOAD_LINK_KEY: 'Download HP Click for free here',
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DOWNLOAD_INSTR_KEY: 'Make sure you have HP Click installed before continuing',
  DOWNLOAD_SMARTSTREAM_KEY: 'Download HP SmartStream',
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Εισαγωγή Dropbox',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'The image size should be less than 1 GB. We accept pdf, png, jpg, svg and tiff formats.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Αναζήτηση Dreamstime',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Εικόνες Dreamstime',
  DUPLICATE_KEY: 'Αντιγραφή',
  EACH_ITEM_PRICE_KEY:
    'Your design includes content from one of our premium content providers. The itemized pricing of each element is summarized below.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Επεξεργασία σχεδίου',
  EDIT_LOWERCASE_KEY: 'edit',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    'Δυστυχώς, παρουσιάστηκε σφάλμα. Δοκιμάστε ξανά αργότερα.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'Παρουσιάστηκε σφάλμα κατά το άνοιγμα του αρχείου PDF που έχετε αποστείλει. ',
  EMAIL_KEY: 'Email',
  EMAIL_ADDRESS_KEY: 'Διεύθυνση email:',
  EMAIL_CHECKBOX_MESSAGE:
    'Γνωρίζω ότι αυτό το άτομο κατανοεί ότι θα λαμβάνει email από την HP, εκ μέρους μου ή εκ μέρους αυτού του παροχέα υπηρεσιών.',
  EXTRA_INFO_KEY: 'Περισσότερες πληροφορίες',
  EMAIL_NOTIFICATION:
    'Θα σας σταλεί σύντομα ένα email. Περιμένετε έως 15 λεπτά για να ολοκληρωθεί η επεξεργασία.',
  EMAIL_DIALOG_MESSAGE:
    'Πληκτρολογήστε τη διεύθυνση email του ατόμου με το οποίο θέλετε να μοιραστείτε το σχέδιό σας.',
  ENTER_KEY: 'Enter',
  EXISTING_FOLDER_KEY: 'Υπάρχων φάκελος',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'Βεβαιωθείτε ότι τα επιλεγμένα στοιχεία είναι σωστά πριν την ολοκλήρωση της παραγγελίας',
  FINAL_CHECK_TITLE_KEY: 'Τελικός έλεγχος',
  FINISH_KEY: 'Τέλος',
  FINISH_LATER_KEY: 'Finish later',
  FIRSTNAME: 'First name',
  FISCAL_NUM: 'Fiscal number',
  FLIP_KEY: 'Αναστροφή',
  FOR_KEY: 'Για',
  FORGOT_PASSWORD_KEY: 'Forgot password?',
  FOTOLIA_KEYWORDS_KEY: 'Λέξεις κλειδιά:',
  FOLDER_NAME: 'Όνομα φακέλου',
  FOLDER_NAME_KEY: 'Όνομα φακέλου:',
  FOLDER_ALREADY_EXIST_KEY: 'Αυτό το όνομα φακέλου υπάρχει ήδη',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    "You've just completed your free poster design",
  FREE_VECTOR_GRAPHICS_KEY: 'free vector graphics',
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Search',
  GOT_IT_MESSAGE_KEY: 'Ok, I got it',
  GROUP_ALL_KEY: 'Ομαδοποίηση όλων',
  GROUP_SCALE: 'Ομαδική κλιμάκωση',
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: 'Δώστε ένα όνομα στο έργο σας',
  HEIGHT_KEY: 'Ύψος',
  HELP_DESCRIPTION_KEY:
    'Let us walk you through the design process. Remember you can open the tour as many times as you want by clicking on the help icon.',
  HELP_KEY: 'Βοήθεια',
  HELPER_TITLE_KEY_1:
    'Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media',
  HELPER_TITLE_KEY_3: 'See all your design work in one place',
  HELPER_TITLE_KEY_4: 'Click Next to preview and finish your final design',
  HERE_KEY: 'here',
  HELP_IMPROVE_KEY:
    'Help improve your productivity and operator efficiency, and expand with color production.',
  HIGH_QUALITY_KEY: 'High-quality',
  IMAGES_TITLE_KEY: 'ΕΙΚΟΝΕΣ',
  IMPERIAL_KEY: 'Imperial',
  IMPORTING_KEY: 'Εισαγωγή',
  INCHES_COLUMN_HEADER_KEY: 'Ίντσες',
  INCHES_KEY: ' ίντσες',
  INCHES_UNIT_STRING_KEY: 'ίν.',
  INVALID_EMAIL_ADDRESS_KEY: 'Μη έγκυρη διεύθυνση email',
  INVALID_INFO_KEY: 'Please enter details.',
  INVALID_NAME_KEY: 'Μη έγκυρο όνομα',
  INVALID_PRINTER_MODEL_KEY: 'Invalid printer model',
  INVALID_SERIAL_NUMBER_KEY: 'Invalid serial number',
  INAVLID_USER_TYPE_KEY: 'Invalid user type',
  INVALID_FILE_SIZE_ERROR_TEXT:
    'Δυστυχώς, το αρχείο που επιλέξατε είναι πολύ μεγάλο. Το μέγιστο μέγεθος αρχείου είναι 500 ΜΒ.',
  INSUFFICIENT_CREDITS_KEY: 'Insufficient credits',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiration',
  I_STOCK_SEARCH_TITLE: 'iStock Search',
  INVALID_FILETYPE_ERROR_TEXT:
    'Η μορφή αρχείου δεν είναι έγκυρη. Μπορούμε να χειριστούμε μόνο pdf, jpg, png, svg και tif.',
  LANDSCAPE_KEY: 'Landscape',
  LANGUAGE_LABLE_KEY: 'Γλώσσα',
  LASTNAME: 'Last name',
  LEARN_MORE: 'Μάθετε περισσότερα',
  LEARN_THE_BASICS_KEY: 'Learn the basics',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'Χρησιμοποιώντας αυτήν την τοποθεσία αποδέχεστε τους περιορισμούς αυτών των',
  LEGAL_FOOTER_MESSAGE2_KEY: 'Αυτή η τοποθεσία συμμορφώνεται με τη',
  LEGAL_FOOTER_MESSAGE3_KEY: 'και τη',
  LENGTH_STRING_IN_INCHES_KEY: 'ίν.',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'change',
  LINK_READER_APP_KEY: 'LinkReader App',
  LINK_READER_APP_DESCRIPTION_KEY:
    'Για να δείτε σε οπτική απεικόνιση το περιεχόμενο που προσθέτετε, κατεβάστε την εφαρμογή LinkReader.',
  LOADING_KEY: 'Φόρτωση...',
  LOADING_TEMPLATE_KEY: 'Loading template',
  LOGIN_NOW: 'Login now',
  LOCK_KEY: 'Κλείδωμα',
  LOGIN_KEY: 'Σύνδεση',
  LOGIN_PATTERN_DESIGN_KEY: 'Login to Pattern design',
  LOGIN_SUBTITLE_KEY: 'Login to see customized pricing and payment details',
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGIN_DREAMSTIME_KEY: 'Σύνδεση στο Dreamstime ',
  LOGOUT_KEY: 'Έξοδος',
  MATERIAL_TITLE_KEY: 'ΥΛΙΚΟ',
  MATERIAL_STRING_KEY: 'Υλικό',
  MEASUREMENT_KEY: 'Measurement',
  METRIC_KEY: 'Metric',
  MINIMUM_ZOOM_WARNING:
    'Αυτό το φόντο δεν μπορεί να μικρύνει άλλο, επειδή έχετε φτάσει στο ελάχιστο απαιτούμενο ύψος ή πλάτος για την κάλυψη του τοίχου σας.',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'Μοντέλο',
  MORE_INFO_TEXT_KEY: 'Περισσότερες πληροφορίες',
  MY_GIFTWRAPS_KEY: 'My Gift Wraps',
  MY_WORK_KEY: 'My work',
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  NAME_KEY: 'Όνομα:',
  NEXT_BUTTON_TITLE_KEY: 'ΕΠΟΜΕΝΟ',
  NEW_FOLDER_KEY: 'Νέος φάκελος',
  NO_SHADOW_KEY: 'Χωρίς σκιά',
  OBJECT_QUANTITY_KEY: 'Quantity',
  OBJECTS_UPPER_CASE_KEY: 'OBJECTS',
  OK_KEY: 'OK',
  ORDER_SAMPLE_KEY: 'Παραγγελία δείγματος',
  ORDER_SAMPLE: 'Παραγγείλετε ένα δείγμα',
  ORDER_SAMPLE_INFOLABEL_1:
    'Επιλέξτε το κομμάτι της εικόνας που θέλετε να παραγγείλετε ως δείγμα',
  ORDER_SAMPLE_INFOLABEL_2:
    'Θα λάβετε με email μια κοντινή προβολή του έργου σας σε πραγματικό μέγεθος',
  ORDER_SAMPLE_INFOLABEL_3:
    'Με αυτόν τον τρόπο θα μπορέσετε να αξιολογήσετε την ποιότητα και την ανάλυσή του',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'Παραγγελία δείγματος τώρα',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'Παραλαβή email που θα περιλαμβάνει μια κοντινή προβολή του έργου σας σε πραγματικό μέγεθος για να αξιολογήσετε την ποιότητα/ανάλυσή του.',
  ORIENTATION_KEY: 'Orientation',
  OTHER_PRINTING_OPTIONS: 'Other printing options',
  PASSWORD_KEY: 'Κωδικός πρόσβασης',
  PATTERN_COLOR_KEY: 'Pattern Color',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'patterns for',
  PDF_GENERATION_ERROR_MESSAGE_KEY: 'Failed to generate pdf. Please try again.',
  PHOTOS_KEY: 'PHOTOS',
  PHOTO: 'photo',
  PHONE: 'Phone',
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'Έχω τα πνευματικά δικαιώματα αυτής της εικόνας και συμφωνώ με',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'The image size should be less than 500 MB. We accept png, jpg, tiff, svg and pdf formats.',
  PIXEL_COLUMN_HEADER_KEY: 'Pixel',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Enter text here...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'π.χ. σημαντικές πληροφορίες που θέλετε να γνωρίζει το κατάστημα εκτύπωσης',
  PLACEHOLDER_INCHES_STRING_KEY: 'ίν.',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'My Poster',
  PORTRAIT_KEY: 'Portrait',
  POSITION: 'Θέση',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium images:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Αποθηκεύστε το έργο σας',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'Το έργο σας έχει αλλαγές που πρέπει να αποθηκευτούν για να συνεχίσετε.',
  PRICE_COLUMN_HEADER_KEY: 'Τιμή',
  PRINTER_SERIAL_NUMBER_KEY: 'Printer serial number*',
  PRINTING_ENABLE_DETAILS_KEY:
    'To enable printing we just need a few more details',
  PRINTER_MODELS_KEY: 'Printer models*',
  PROCESSING_KEY: 'Επεξεργασία...',
  PROCESSING_ALERT_TXT:
    'Do not close this window while we are processing your design',
  PROCESSING_ALERT_TXT2:
    'Once processing has been completed, HP Click will open automatically and start downloading your file',
  PROCESSING_DONE: 'You are almost done!',
  PROCESSING_FILE_TXT: 'Your file is being processed.',
  PROCESSING_TIME_TXT:
    'This may take some time as we are composing your creation to ensure the best image quality',
  PROCESSING_ALERT_TXT3:
    'Your PDF will be automatically downloaded to your computer',
  PROCESSING_ALERT_TXT4:
    'Remember you can configure your JDF connection for automation in settings',
  PREMIUM_CONTENT_KEY: 'Premium Content',
  PREVIEW_KEY: 'Προεπισκόπηση',
  PROFESSIONAL_USE_TITLE_KEY: 'professional use.',
  PROJECT_NAME_KEY: 'Όνομα έργου',
  PROJECT_NAME: 'Όνομα έργου:',
  PROJECT_ALREADY_EXIST_KEY: 'Αυτό το όνομα έργου υπάρχει ήδη',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'Αυτό το όνομα έργου υπάρχει ήδη',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'Αυτό το όνομα φακέλου υπάρχει ήδη',
  PIXELATION_WARNING_KEY: 'Προειδοποίηση πιξελοποίησης',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'Λόγω της ανάλυσης της μεταφορτωμένης φωτογραφίας σας, το δέρμα σας ενδέχεται να παραμορφωθεί ή να παραμορφωθεί. Για να βεβαιωθείτε ότι δεν υπάρχει θόλωση, ανεβάστε μια εικόνα καλής ποιότητας και αποφύγετε το τέντωμα της εικόνας. Εάν είστε ικανοποιημένοι με την προεπισκόπηση και θέλετε να συνεχίσετε, συνεχίστε την υποβολή.',
  REGISTER_CONTACTINFO: 'Contact information',
  REGISTER_INFO: 'Register information',
  REGISTER_PATTERNSUB1: 'As a value HP customer,',
  REQUIRED_FIELDS_KEY: 'Required fields',
  REQUIRED_FIELDS_TEXT_KEY: 'Required fields',
  REQUIRED_STRING_KEY: 'ΥΠΟΧΡΕΩΤΙΚΟ',
  RECOLOR_KEY: 'Αλλαγή χρώματος',
  RADICALLY_SIMPLE_KEY: 'Radically simple printing software',
  RIPSELECTION_HEAD:
    'This is your first time, select your prefered compatible printing software',
  RIPSELECTION_DESC:
    'Your selection will become your default printing option path for future print outs. Changes can be made later in settings',
  REGISTER_COMPANYINFO: 'Company information',
  REGISTER_KEY: 'Register',
  REGISTER_NOW: 'Register now',
  REOLOR_KEY: 'Αλλαγή χρώματος',
  REQUEST_SAMPLE_KEY: 'Ζητήστε ένα δείγμα',
  RESIZE_KEY: 'Resize',
  RESIZE_ARBITRARILY_KEY: 'Resize Arbitrarily',
  RESIZE_PROPORTIONALLY_KEY: 'Resize Proportionally',
  REVIEW_AND_SUBMIT_KEY: 'Review and Submit',
  REQUEST_FOR_QUOTATION: 'Αίτημα για προσφορά',
  RIGHT_LOGO_TEXT_KEY: 'κατά',
  ROTATE_KEY: 'Περιστροφή',
  ROTATE_LEFT_KEY: 'Περιστροφή 90° αριστερά',
  ROTATE_RIGHT_KEY: 'Περιστροφή 90° δεξιά',
  ROTATION_KEY: 'Περιστροφή',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Σειρές και στήλες',
  ROYALTY_FREE_KEY: 'royalty-free',
  ROYALTY_KEY: 'royalty',
  SALUTATION: 'Salutation',
  SAVE_KEY: 'Αποθήκευση',
  SAVING_KEY: 'Αποθήκευση...',
  SAVE_INSPIRATION: 'Save inspiration',
  SAVE_TEMPLATE: 'Save template',
  SAVE_DIALOG_TITLE: 'Αποθηκεύστε το έργο σας',
  SAVE_PROJECT_NAME_KEY: 'Αποθηκεύστε το έργο σας πρώτα',
  SAVEDIALOG_MESSAGE:
    'Συνδεθείτε για να αποθηκεύσετε το έργο σας. Εάν δεν έχετε λογαριασμό, θα σας βοηθήσουμε να δημιουργήσετε έναν. Η πρόοδος που έχετε κάνει δεν θα χαθεί.',
  SEAMLESS_KEY: 'seamless',
  SCALE_INFO_STRING_KEY: 'Scale the image to fit with on your design',
  SCALE_KEY: 'Κλιμάκωση',
  SCALE_ALL_KEY: 'Κλιμάκωση όλων',
  SCALE_TO_FILL_KEY: 'Scale To Fill',
  SEARCH_BUTTON_TITLE_KEY: 'Αναζήτηση',
  SELECT_CUSTOM_SIZE_KEY: 'Select custom size',
  SELECT_CUSTOM_KEY: 'Custom',
  SEARCH_TITLE: 'Αναζήτηση',
  SELECTED_IMAGE_KEY: ' Selected Image: ',
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Select Gift Wraps size',
  SELECT_COUNTRY: 'Select Country',
  SELECT_SALUTATION: '---Select---',
  SELECT_POSTER_SIZE_KEY: 'Select poster size',
  SELECT_PRINTING_OPTION_KEY: 'Select your prefered printing option',
  SEND_INSTALLATION_INSTRUCTION_KEY: 'Να μου σταλούν οδηγίες εγκατάστασης',
  SEND_TO_BACK_KEY: 'Μεταφορά πίσω',
  SEND_KEY: 'Αποστολή',
  SEND_TO_PRINT_TITLE_KEY: 'Send to print',
  SET_SIZE_KEY: 'Ορισθμός μεγέθους',
  SETTINGS_KEY: 'Ρυθμίσεις',
  SETTINGS_UPPERCASE_KEY: 'SETTINGS',
  SHARE_KEY: 'Κοινή χρήση',
  SIGNED_IN_AS_KEY: 'Signed in as',
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Sign in or register to see customized pricing and payment details',
  SIGN_UP_NOW_KEY: 'Sign up now',
  SKIP_KEY: 'Skip',
  SOLID_COLORS_KEY: 'Solid Colors',
  SQFT_UNIT_STRING_KEY: 'τετ. πόδια',
  SQM_UNIT_STRING_KEY: 'τετ. μ.',
  START_TOUR_KEY: 'Start tour',
  STATUS_MSG: 'Your file has been sent to print!',
  SUBMIT_BUTTON_KEY: 'υποβάλλουν',
  SHARE_LINK_LABEL: 'Επιλέξτε τον τύπο του συνδέσμου που θέλετε να μοιραστείτε',
  SHARE_EDIT_LINK: 'Επεξεργασία συνδέσμου',
  SHARE_VIEW_LINK: 'Προβολή συνδέσμου',
  SHARE_YOUR_CREATION: 'Share your creation!',
  STREET_ADD: 'Street address',
  TARGET_VIEWING_HINT:
    '* Μπορείτε να αλλάξετε την απόσταση προβολής από τις ρυθμίσεις.',
  TERMS1_KEY: 'όρων',
  TERMS2_KEY: 'Δήλωση απορρήτου της HP',
  TERMS3_KEY: 'Σημείωση δικαιωμάτων προσωπικών δεδομένων της HP',
  TERMS_OF_USE_KEY: 'Terms of use',
  TERMS_OF_USE: 'Όροι χρήσης',
  TEXT_SHADOW_COLOR_KEY: 'Text shadow Color',
  TEXT_UPPERCASE_KEY: 'TEXT',
  TILE_KEY: 'Παράθεση',
  TOTAL_KEY: 'ΣΥΝΟΛΟ',
  TOTAL_PRICE_KEY: 'Total:',
  TRANSPARENCY_KEY: 'Transparency',
  TEMPLATES_KEY: 'templates',
  TEMPLATES_UPPER_CASE_KEY: 'TEMPLATES',
  THANK_YOU_KEY: 'Σας ευχαριστούμε',
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'Ξεκλείδωμα',
  UNGROUP_KEY: 'Κατάργηση ομαδοποίησης',
  UPDATE_TEXT_KEY: 'Ενημέρωση',
  UPLOAD_KEY: 'Αποστολή εικόνας',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Upload your own image',
  UPLOAD_UPPERCASE_KEY: 'UPLOAD',
  USER_NAME: 'Όνομα χρήστη',
  USER_TYPE_TITLE_KEY: 'What type of user are you*',
  UNTILE_KEY: 'Αναίρεση παράθεσης',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Search',
  VALIDITY_KEY: 'Ισχύς',
  VANILLA_LOGIN_DIALOG_KEY:
    'Join for free to save and print your design and see your saved work',
  VANILLA_PREVIEW_MESSAGE_KEY:
    'This is the preview of your design, check the design is final before proceeding or select edit to make any changes',
  VAT_KEY: 'ΦΠΑ',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vector',
  VIEW_FOTOLIA_KEY: 'Εμφάνιση στο Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'View in Getty Image©',
  VIEW_I_STOCK_KEY: 'View in iStock©',
  VIEW_DESIGN_DETAILS_KEY: 'Προβολή στοιχείων σχεδίου',
  VIEW_DESIGNER_PROFILE_KEY: 'Προβολή προφίλ εφαρμογής σχεδίασης',
  VIEW_PRICE_KEY: 'Εμφάνιση τιμής',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',
  WALL_POSTER_KEY: 'Αφίσα',
  WALL_SIZE_TEXT_KEY: 'Wall size',
  WARNING_KEY: 'Προειδοποίηση',
  WEBSITE: 'Website',
  WIDTH_KEY: 'Πλάτος',
  YOU_CAN_ALWAYS_ACCESS: 'You can always access your designs in ',
  YOUR_NAME_KEY: 'Το όνομά σας',
  YOUR_SELECTION_WILL_KEY:
    'Your selection will become your default printing path for future print outs.',
  YOUR_PROJECT_KEY: 'Το έργο σας:',
  PROJECT_NAME_ERROR_TEXT: 'Εισαγάγετε ένα όνομα για το έργο.',
  PROJECT_FOLDER_ERROR_TEXT: 'Εισαγάγετε ένα όνομα για το φάκελο του έργου.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixel warning settings',
  MINIMUM_VIEWING_DISTANCE_KEY: 'Ελάχιστη απόσταση προβολής',
  BACKGROUND_UPLOAD_KEY: ' background ',
  OBJECT_UPLOAD_KEY: ' object ',
  PHOTO_UPLOAD_KEY: ' photo ',
  NO_DREAMSTIME_ERROR_MESSAGE: 'Δεν βρέθηκαν dreamstime Περιεχόμενα βρέθηκα',
  NO_ELEMENT_ERROR_MESSAGE: 'Δεν βρέθηκε στοιχείο.',
  NO_MORE_IMAGES_FOUND_KEY: 'Δεν βρέθηκαν περισσότερες εικόνες',
  NO_PATTERN_ERROR_MESSAGE: 'Δεν βρέθηκαν μοτίβα.',
  TEXT_ANCHOR_MIDDLE: 'Center',
  TOUR_DESCRIPTION_TEXT:
    'Let us walk you through the design process. Remember you can re-open the tour at any time by clicking on the help icon.',

  ALREDY_HAVE_AN_ACCOUNT: 'Already have a {0} account?',
  CHANGE_MEASURING_SYSTEM_KEY: 'Change to {0}',
  DOWNLOADS_KEY: '{0} downloads',
  HEX_COLOR_KEY: 'Hex color: {0}',
  NEAR_KEY: 'Near',
  FAR_KEY: 'Far',
  CLOSE_UP_KEY: 'Close Up',
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'The images you are trying to use are either smaller or larger than the design area you are using.',
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'To get better results use a {0} X {1} resolution image',
  MESSAGE_KEY: 'Μήνυμα:',
  VIEWS_KEY: '{0} views',
  COST_DESCRIPTION_MESSAGE_KEY:
    'This is the summary of the cost related to the premium content included in your design. {0} By selecting finish you agree to be charged the following cost by the content providers.',
  DEFAULT_PRINTING_OPTION_KEY: '{0} is your default printing option,',
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: "Don't have a Dreamstime account yet?",
  REGISTER_PATTERNSUB2:
    ' you will recieve $100 worth of high-resolution images {0} to help with all your creative needs!',
  REGISTER_PATTERNSUB3:
    'Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs.',
  ZOOM_WARNING_PIXELATED_TEXT:
    'Έχετε εφαρμόσει κλιμάκωση σε τέτοιο βαθμό που η εκτυπωμένη εικόνα μπορεί να έχει παραμορφωμένα pixel κατά τη θέαση στα {0} {1} * (η τρέχουσα ανάλυση εκτύπωσης είναι  {2} dpi).',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'Η συνιστώμενη απόσταση θέασης είναι {0} {1}. Εάν η απόσταση αυτή δεν είναι κατάλληλη, μειώστε την κλίμακα αυτής της εικόνας ή το μέγεθος του σχεδίου.',
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'Το συνιστώμενο ελάχιστο μέγεθος πρέπει να είναι {0} x {1} pixel.',
  UPLOAD_STATUS: '{0}% από {1}MB',
  REGISTER_TO: 'Register to {0}',
  MINIMUM_DIMENSIONS_KEY: 'Οι ελάχιστες διαστάσεις είναι {0} (π) x {1} (υ).',
  MINIMUM_HEIGHT_KEY: 'Το ελάχιστο ύψος είναι {0}.',
  MINIMUM_WIDTH_KEY: 'Το ελάχιστο πλάτος είναι {0}',
  MAXIMUM_DIMENSIONS_KEY: 'Maximum dimensions are {0} (w) by {1} (h).',
  MAXIMUM_WIDTH_KEY: 'Το μέγιστο πλάτος είναι {0}',
  MAXIMUM_HEIGHT_KEY: 'Το μέγιστο ύψος είναι {0}.',
  INVALID_NUMBER_ERROR_TEXT_KEY:
    'Εισαγάγετε αριθμητικές διαστάσεις μεγαλύτερες από το μηδέν.',
  PROCESSING_FAILED: 'Η επεξεργασία απέτυχε. Δοκιμάστε σε λίγο',
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT:
    'Λυπούμαστε, τα κρυπτογραφημένα αρχεία PDF δεν υποστηρίζονται.',
  DROPBOX_UPLOAD_PROGRESS_KEY: 'Εισαγωγή αρχείου {0} από {0}',
  RECOLORING_KEY: 'Αλλαγή χρώματος...',
  TEXT_COLOR_KEY: 'Text Color',
  SOLID_COLOR_KEY: 'Solid Color',
  AUTHENTICATE_DIALOG_TITLE:
    'Αυτή η προέλευση περιεχομένου προστατεύεται με κωδικό πρόσβασης',
  AUTHENTICATE_FAILED_MESSAGE: 'Ο έλεγχος ταυτότητας απέτυχε!',
  DROPBOX_IMPORT_ERROR_HEADER:
    'Υπήρξε πρόβλημα με την εισαγωγή ορισμένων αρχείων',

  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    'Δυστυχώς, τα πολυσέλιδα PDF δεν υποστηρίζονται.',
  HP_FEEDBACK_TEXT: 'HP wants your feedback',
  FEEDBACK_QUERY_TEXT: 'Overall, how satisfied are you with our solutions?',
  VERY_SATISFIED_BUTTON_TEXT: 'Very Satisfied',
  SATISFIED_BUTTON_TEXT: 'Satisfied',
  DISSATISFIED_BUTTON_TEXT: 'Dissatisfied',
  VERY_DISSATISFIED_BUTTON_TEXT: 'Very Dissatisfied',
  FEEDBACK_IMPROVE_TEXT: 'What can we do to improve?',
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacy Statement',
  FEEDBACK_PLACEHOLDER_TEXT:
    "We review your feedback to improve our products, so please don't share any personal data or confidential/propreitary content",
  DEFAULT_PROJECT_NAME: 'Project',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Choose your laptop',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'First name',
  LAST_NAME_KEY: 'Last name',
  PHONE_NUMBER_KEY: 'Phone No.',
  POSTAL_ADDRESS: 'Postal address',
  COMPANY_NAME: 'Company name',
  INVALID_PHONE_NUMBER_KEY: 'Invalid phone number',
  INVALID_POSTAL_ADDRESS: 'Invalid Postal address',
  INVALID_COMPANY_NAME: 'Invalid Comapany name',
  TERMS_AND_CONDITIONS: 'I accept the terms and conditions.',
  INVOICE_UPLOAD: 'Upload Invoice',
  INVOICE_FILE_MISSING: 'Invoice file missing',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* You can find detailed information about HP’s data collection principles on HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'I accept that my personal information will be shared with HP to be contacted about future HP campaigns. *',
  SERVICE_PROVIDER_CONDITION:
    'I accept that the data I provide may be shared with service providers for the purposes of printing and delivery process.',
  ORDER_DESIGN: 'Order design',
  SUBMIT_YOUR_DESIGN: 'Submit your design',
  SUBMISSION_DESIGN_ORDER: 'Submission for design order',
  ENTER_REQUIRED_FIELDS_KEY: 'Please enter required fields',
  ADDRESS_KEY: 'Address',
  INVALID_ADDRESS_KEY: 'Invalid address',
  CITY_KEY: 'City',
  INVALID_CITY_KEY: 'Invalid city',
  COUNTRY_KEY: 'Country',
  STATE_KEY: 'State',
  ZIP_KEY: 'Zip',
  INVALID_ZIP_KEY: 'Invalid zip code',
  ORDER_NUMBER: 'Order number',
  YOUR_DETAILS_KEY: 'Οι λεπτομέρειές σου',
  APPLY_DESIGN_COMPETITION: 'Apply for the design competition',
  NOTICE_KEY: 'Ειδοποίηση:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'Για να έχετε ένα δέρμα υπολογιστή τέλεια προσαρμοσμένο στις δικές σας, πρέπει να επιλέξετε το ακριβές μοντέλο που αντιστοιχεί στην αγορά, όπως φαίνεται στο τιμολόγιο.',
  RESTART_PROJECT_ALERT_TITLE: 'Restart a project ?',
  DISCARD_ALERT_MESSAGE: 'Your current project will be discarded',
  RESTART: 'Restart',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'Προειδοποίηση μεγέθους σελίδας!',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'Αυτό το πρότυπο Inspiration συνοδεύεται από προεπιλεγμένο μέγεθος {0} X {1} {2}. Το μέγεθος της σελίδας σας θα αλλάξει αυτόματα ώστε να ταιριάζει σε αυτό το πρότυπο.',
  MODIFY_SIZE_WARNING:
    'Εάν θέλετε να αλλάξετε το μέγεθος αυτού του σχεδιασμού, μπορείτε να το κάνετε στην καρτέλα "Ρυθμίσεις". Τα στοιχεία σχεδίασης ενδέχεται να απαιτούν επεξεργασία για προσαρμογή στις επιθυμητές διαστάσεις.',
  RANDOMIZE_KEY: 'Τυχαία',
  MATERIAL_CHOICE_APPLIED: 'Επιλογή υλικού που εφαρμόστηκε.',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: 'πιστοποιητικό',
  AUTHENTICITY_STRING: 'αυθεντικότητα',
  PLEASE_WAIT: 'Παρακαλώ περιμένετε',
  PROTECTING_YOUR_DATA: 'προστατεύοντας τα δεδομένα σας...',
  SEARCH_YOUR_LAPTOP_KEY: 'Αναζήτηση στον φορητό υπολογιστή σας', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'Ωχ! Δεν μπορούσαμε να βρούμε φορητούς υπολογιστές για την αναζήτησή σας.', // Google translated

  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',
  SERIAL_NUMBER_KEY: 'Σειριακός αριθμός',
  LOCKED_PROJECT: 'Κλειδωμένο έργο',
  LOCKED_MESSAGE:
    'Αυτό το έργο έχει παραγγελθεί και δεν μπορεί να τροοποιηθεί. Μπορείτε μόνο να το προβάλλετε.',
  EXPIRED_PROJECT: 'Ληγμένο έργο',
  EXPIRED_MESSAGE: 'Αυτό το έργο έχει λήξει.',
  DELETED_PROJECT: 'Διαγραμμένο έργο',
  DELETED_MESSAGE: 'Αυτό το έργο έχει διαγραφεί.',
  CHOOSE_GROUP_TYPE: 'Επιλέξτε τύπο {0}',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Εισαγάγετε αριθμούς μεγαλύτερους από μηδέν.',
  SIZE_KEY: 'Μέγεθος',
  DISTANCE_FROM_KEY: 'Distance from',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: 'Furniture',
  FIXTURES_KEY: 'Fixtures',
  ADD_A_WALL_KEY: 'Add a wall',
  SELECT_A_WALL_KEY: 'Select a Wall',
  LEFT_KEY: 'Left',
  RIGHT_KEY: 'Right',
  DELETE_WALL_KEY: 'Delete a wall',
  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Choose canvas type',
  MAXIMUM_WALL_SIZE_KEY: 'Το μέγιστο μέγεθος του τοίχου είναι {0}τετ. {1}.',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY:
    'Το ύψος του καμβά υπερβαίνει το ύψος του τοίχου.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY:
    'Το πλάτος του καμβά υπερβαίνει το πλάτος του τοίχου.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'Μέγιστος αριθμός στηλών για το τρέχον ύψος: {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    'Μέγιστος αριθμός σειρών για το τρέχον ύψος: {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'Το πλάτος του τοίχου είναι μικρότερο από το πλάτος του καμβά.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY:
    'O τοίχος πρέπει να έχει ελάχιστο πλάτος {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY:
    'Ο τοίχος πρέπει να έχει ελάχιστο ύψος {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'Το ύψος του τοίχου είναι μικρότερο από το ύψος του καμβά.',
  MAXIMUM_WALL_HEIGHT_KEY: 'Το μέγιστο ύψος του τοίχου είναι {0} {1}.',
  FINISHING_KEY: 'Finishing',
  MIRROR_KEY: 'Mirror',
  NATURAL_KEY: 'Natural',
  ROWS_KEY: 'Σειρές',
  COLUMNS_KEY: 'Στήλες',
  DEFAULT_WALL_SIZE_KEY: 'Default Wall Size',
  EDIT_KEY: 'Επεξεργασία',
  TOP_KEY: 'Πάνω',
  BOTTOM_KEY: 'Κάτω'
};
